export const COUNT_ALPHABET_CHARS = 26;
export const START_ALPHABET_CHAR_CODE = 64;

export const VERB_URL = 'http://adlnet.gov/expapi';
export const X_API_ZANICHELLI = 'https://api.zanichelli.it/xapi';
